<template>
    <div class="r2s0form">
        <div class="own-input">
            <label for="name">{{ $t('f_name_label') }}</label>
            <info-tip :text="$t('f_name_tip_text')" />
            <input
                id="name"
                v-model="name"
                v-validate="'name'"
                v-m-android-focus
                name="name"
                :placeholder="$t('f_name_placeholder')"
                type="text"
                :data-vv-scope="scope">
            <span class="error-message">{{ errors.first(`${scope}.name`) }}</span>
        </div>

        <div id="r2s2">
            <div class="own-input">
                <label>{{ $t('f_number_of_passenger_label') }}</label>
                <count-input
                    v-model="people"
                    :decrement="removeLastTraveler"
                    :increment="addTraveler"
                    readonly
                    text="" />
            </div>

            <h2 class="title">
                {{ $t('f_r2s2_title') }}
            </h2>

            <r2s1traveler
                v-for="(traveler, i) of filteredTravelersList"
                :key="i+1"
                :index="i+1"
                :traveler="traveler" />

            <div class="add-traveler" @click="addTraveler">
                <span class="plus">+</span> <span class="underline">{{ $t('f_add_traveler_btn') }}</span>
            </div>
        </div>

        <div v-show="!editable" class="agreement">
            <div class="own-input">
                <label class="checkbox-container">
                    <input
                        id="terms"
                        v-model="terms"
                        v-validate="'required'"
                        v-m-android-focus
                        name="terms"
                        type="checkbox"
                        :data-vv-scope="scope">
                    <span class="checkmark" />
                </label>
                <div class="text condition" v-html="$t('f_i_accept', [$t('f_url_terms_and_conditions'), $t('f_url_data_protection_policy'), `https://www.sign-seal.com/user_agreement?locale=${locale}`])" />
            </div>
            <span class="error-message">{{ errors.first(`${scope}.terms`) }}</span>
        </div>

        <server-errors v-if="serversErrors" :message="serversErrors" />

        <div v-show="editable" class="own-input next-prev-wrap">
            <div class="btn btn-link prev" @click="cancelEditingWrap()">
                {{ $t('f_cancel') }}
            </div>
            <div :class="['btn btn-orange', {'invalid': formIsInvalid(scope), 'progress': loading}]" @click="save">
                <span v-show="!loading">{{ $t('f_save') }} &#10093;</span>
                <div v-if="loading" class="spinner">
                    <div class="rect1" />
                    <div class="rect2" />
                    <div class="rect3" />
                    <div class="rect4" />
                    <div class="rect5" />
                </div>
            </div>
        </div>

        <div v-show="!editable" class="own-input next-prev-wrap">
            <div class="btn btn-link prev" @click="prevStep">
                &#10092; {{ $t('f_back') }}
            </div>
            <div :class="['btn btn-orange', {'invalid': formIsInvalid(scope), 'progress': loading}]" @click="next">
                <span v-show="!loading">{{ $t('f_continue') }} &#10093;</span>
                <div v-if="loading" class="spinner">
                    <div class="rect1" />
                    <div class="rect2" />
                    <div class="rect3" />
                    <div class="rect4" />
                    <div class="rect5" />
                </div>
            </div>
        </div>

        <div style="clear: both" />
    </div>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import {createHelpers} from 'vuex-map-fields'
  import CountInput from '../common/CountInput'
  import formNavMixin from '../mixins/formNavMixin'
  import R2s1traveler from './R2s0traveler'

  const { mapFields } = createHelpers({
    getterType: 'round2/getComplaintField',
    mutationType: 'round2/UPDATE_COMPLAINT_FIELD'
  })
  
  const { mapMultiRowFields } = createHelpers({
    getterType: 'travelers/getField',
    mutationType: 'travelers/updateField'
  })

  export default {
    components: { CountInput, R2s1traveler },
    mixins: [formNavMixin],
    inject: ['$validator'],
    props: {
      editable: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        module: 'round2',
        travelers: [{ name: '', email: '' }]
      }
    },
    computed: {
      ...mapGetters({
        countriesMapper: 'round1/countriesMapper',
        defaultCountry: 'round1/defaultCountry'
      }),
      ...mapFields([
        'name',
        'address',
        'zip_code',
        'city',
        'country',
        'terms'
      ]),
      ...mapMultiRowFields({
        travelersList: 'list'
      }),
      scope() {
        return this.editable ? 'r2s0formEditable' : 'r2s0form'
      },
      locale(){
        return this.$i18n.locale
      },
      people: function(){
        return this.$store.state.travelers.people
      },
      filteredTravelersList: function(){
        return this.travelersList.filter((traveler) => !traveler.for_destroy)
      }
    },
    methods: {
      ...mapMutations({
        cancelEditing: 'round1/CANCEL_EDITING',
        applyEditing: 'round1/APPLY_EDITING',
        addTraveler: 'travelers/ADD',
        removeTraveler: 'travelers/REMOVE',
      }),
      ...mapActions({
        validation: 'round1/validation'
      }),
      removeLastTraveler: function() {
        let lastItem = this.filteredTravelersList[this.filteredTravelersList.length - 1]
        if (lastItem){ this.removeTraveler(lastItem.id) }
      },
      next() {
      this.formSubmittion({ scope: `*`, formSelector: '#r2s0' }).then(({ success, fail }) => {
        this.$store.dispatch("round2/putComplaint", this.$store.getters['round2/r2s0FormData']).then(() => {
          this.$store.commit('round2/NEXT_STEP');
            success();
          }).catch((response) => {
            fail(response);
          });
        });
      },
      cancelEditingWrap() {
        this.cancelEditing()
        this.scrollToHeader();
      },
      save(){
        this.formSubmittion({scope: 'r2s0formEditable.*', formSelector: '.r2s0form.editable'}).then(({success}) => {
          this.applyEditing()
          this.$validator.validate('r1s3.*').then((isValid) => {
            if(isValid){this.scrollToHeader()}
            else{ this.scrollToInvalidField('#r1s3') }
            success()
          })
        })
      },
      scrollToHeader() {
        let correction = (this.$device.desktop() ? 40 : 90),
          y = (window.cfs.offset(document.querySelector('#r1s3 .form-2')).top) - correction
        window.scrollTo({top: y, behavior: 'smooth'})
      }
    }
  }
</script>

<style lang="scss">
  .r2s0form {

    .own-input{
      .content{
        bottom: 110px;
      }
    }

    .own-input.country{
      .content{
        bottom: 90px;
      }
    }

    .own-input.email{
      .content{
        bottom: 212px;
      }
    }

    .zip-code {
      width: 45%;
    }

    .travelers {
      margin-top: 20px;
      background: #f7f7f7;
      border-radius: 8px;
      padding: 15px;

      .traveler-inputs {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        input[type="text"],
        input[type="email"] {
          flex: 1;
          margin-right: 10px;
          border: 1px solid #ccc;
          padding: 10px;
          border-radius: 4px;
        }

        button {
          background: #ff6a00;
          color: white;
          border: none;
          padding: 10px 15px;
          border-radius: 4px;
          cursor: pointer;

          &:hover {
            background: darken(#ff6a00, 10%);
          }
        }
      }
    }
  }
</style>
